// extracted by mini-css-extract-plugin
export default {"statsContainer":"stats_statsContainer__qm7mo","vr":"stats_vr__iFxaD","number":"stats_number__tpMiB","label":"stats_label__Nyq01","lightLabel":"stats_lightLabel__FEDfh"};